import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const feedviewsRequest = createAction(types.FEEDVIEWS_REQUEST);
export const feedviewsSuccess = createAction(types.FEEDVIEWS_SUCCESS);
export const feedviewsFailure = createAction(types.FEEDVIEWS_FAILURE);

export const feedviewRequest = createAction(types.FEEDVIEW_REQUEST);
export const feedviewSuccess = createAction(types.FEEDVIEW_SUCCESS);
export const feedviewFailure = createAction(types.FEEDVIEW_FAILURE);

export const createFeedviewRequest = createAction(
  types.CREATE_FEEDVIEW_REQUEST,
);
export const createFeedviewSuccess = createAction(
  types.CREATE_FEEDVIEW_SUCCESS,
);
export const createFeedviewFailure = createAction(
  types.CREATE_FEEDVIEW_FAILURE,
);

export const modifyFeedviewRequest = createAction(
  types.MODIFY_FEEDVIEW_REQUEST,
);
export const modifyFeedviewSuccess = createAction(
  types.MODIFY_FEEDVIEW_SUCCESS,
);
export const modifyFeedviewFailure = createAction(
  types.MODIFY_FEEDVIEW_FAILURE,
);

export const deleteFeedviewRequest = createAction(
  types.DELETE_FEEDVIEW_REQUEST,
);
export const deleteFeedviewSuccess = createAction(
  types.DELETE_FEEDVIEW_SUCCESS,
);
export const deleteFeedviewFailure = createAction(
  types.DELETE_FEEDVIEW_FAILURE,
);

export const resetFeedview = createAction(types.RESET_FEEDVIEW);

export default {
  resetFeedview,
  feedviewsRequest,
  feedviewsSuccess,
  feedviewsFailure,
  feedviewRequest,
  feedviewSuccess,
  feedviewFailure,
  createFeedviewRequest,
  createFeedviewSuccess,
  createFeedviewFailure,
  modifyFeedviewRequest,
  modifyFeedviewSuccess,
  modifyFeedviewFailure,
  deleteFeedviewRequest,
  deleteFeedviewSuccess,
  deleteFeedviewFailure,
};
